<mat-nav-list class="sidebar-nav">
  @for (item of menuItems(); track item) {
  <a mat-list-item class="menu-item" [routerLink]="item.route" routerLinkActive="active-menu-item"
    [class.expanded]="isSubmenuOpen(item)" (click)="toggleSubmenu(item, $event)">

    <div class="menu-item-content">
      <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
      <span class="menu-label">{{ item.label | translate }}</span>

      @if (hasSubmenu(item)) {
      <mat-icon class="expand-icon">
        {{ isSubmenuOpen(item) ? 'expand_less' : 'expand_more' }}
      </mat-icon>
      }
    </div>
  </a>

  @if (isSubmenuOpen(item) && hasSubmenu(item)) {
  <div class="submenu-level-1">
    @for (subItem of item.submenu; track subItem) {
    <a mat-list-item class="submenu-item" [routerLink]="subItem.route" routerLinkActive="active-menu-item"
      [class.expanded]="isSubmenuOpen(subItem)" (click)="toggleSubmenu(subItem, $event)">

      <div class="submenu-item-content">
        <mat-icon matListIcon>{{ subItem.icon }}</mat-icon>
        <span class="submenu-label">{{ subItem.label | translate }}</span>

        @if (hasSubmenu(subItem)) {
        <mat-icon class="expand-icon">
          {{ isSubmenuOpen(subItem) ? 'expand_less' : 'expand_more' }}
        </mat-icon>
        }
      </div>
    </a>

    @if (isSubmenuOpen(subItem) && hasSubmenu(subItem)) {
    <div class="submenu-level-2">
      @for (subSubItem of subItem.submenu; track subSubItem) {
      <a mat-list-item class="subsubmenu-item" [routerLink]="subSubItem.route" routerLinkActive="active-menu-item">

        <div class="subsubmenu-item-content">
          <mat-icon matListIcon>{{ subSubItem.icon }}</mat-icon>
          <span class="subsubmenu-label">{{ subSubItem.label | translate }}</span>
        </div>
      </a>
      }
    </div>
    }
    }
  </div>
  }
  }
</mat-nav-list>